import React from 'react';

import { Div, Text } from '@pinpoint/design-kit';

function Footer() {
	return (
		<Div d="flex" flexDir="column" m={{ t: '.75rem', b: '.75rem' }} w="100%">
			<Text textColor="brand500" textSize="body" textWeight="800">
				ASSUMPTIONS
			</Text>
			<Text textColor="shade4D" textSize="body">
				<Text tag="span" textWeight="700">
					Cancellations:&nbsp;
				</Text>
				Spread equally across all deciles
			</Text>
			<Text textColor="shade4D" textSize="body">
				<Text tag="span" textWeight="700">
					Non-Renewals:&nbsp;
				</Text>
				Occur in the highest risk decile with remaining policies in force (starting in decile #10)
			</Text>
			<Text textColor="shade4D" textSize="body">
				<Text tag="span" textWeight="700">
					New Business:&nbsp;
				</Text>
				New policies are spread across Pinpoint growth deciles as shown in the &quot;Pinpoint New Business
				Distribution&quot; column
			</Text>
		</Div>
	);
}

export default Footer;
